// Core
import QS from "qs";
import { AxiosRequestConfig } from "axios";
import { http } from "@/network/http-provider";

// Definitions
import { IPromoFieldFetch, UserAcceptRequestType, UserChangeRequestType } from "./types";
import { HttpRequestParams } from "@/types/http";

// Utils
import { promotionKeys } from "./apiKeys";

export const promotionApi = Object.freeze({
  list: (payload: HttpRequestParams<IPromoFieldFetch>) => {
    const { params } = payload;
    const config = {
      params,
      paramsSerializer: (p: AxiosRequestConfig): string =>
        QS.stringify(p, { encode: true, arrayFormat: "indices" }),
    };
    return http.get<any>(promotionKeys.list, config);
  },
  userList: (payload: HttpRequestParams) => {
    const { configOptions } = payload;
    return http.get<any>(promotionKeys.userList, { ...configOptions });
  },
  accept: (payload: HttpRequestParams<UserAcceptRequestType>) => {
    const { data, configOptions } = payload;
    return http.put<any>(promotionKeys.accept, data, configOptions);
  },
  change: (payload: HttpRequestParams<UserChangeRequestType>) => {
    const { data, configOptions } = payload;
    return http.post<any>(promotionKeys.change, data, configOptions);
  },
});
